import { LinkType } from "@components/Link/Link";
import React from "react";
import ColumnsTemplate from "./ColumnsTemplate";

export type NavbarTopic = {
	id: number;
	title: string;
	to?: LinkType;
	description?: string;
	topics?: NavbarTopic[];
	icon?: JSX.Element;
};

export const links: NavbarTopic[] = [
	{
		id: 1,
		title: "Inventory",
		topics: [
			{
				id: 1,
				title: "Virtual freezers",
				to: "INVENTORY",
				description: "Digitalized sample storage",
				icon: (
					<svg
						width="22"
						height="22"
						viewBox="0 0 22 22"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M17.0623 7.5L4.93792 14.5M17.0623 7.5L18.1604 3.40192M17.0623 7.5L21.1604 8.59808M4.93792 14.5L0.839844 13.4019M4.93792 14.5L3.83984 18.5981M17.0622 14.4999L4.93784 7.49986M17.0622 14.4999L21.1604 13.4018M17.0622 14.4999L18.1604 18.598M4.93784 7.49986L3.83999 3.40203M4.93784 7.49986L0.839986 8.59819M11.0001 4L11.0001 18M11.0001 4L8.0001 1M11.0001 4L14.0001 1M11.0001 18L8.0001 21M11.0001 18L14.0001 21"
							stroke="#2C52F7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				),
			},
			{
				id: 3,
				title: "Consumables",
				to: "CONSUMABLES",
				description: "Manage lab consumables",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_235_5541)">
							<path
								d="M4.50004 12.5L12.5 4.50004C13.4283 3.57178 14.6873 3.05029 16 3.05029C17.3128 3.05029 18.5718 3.57178 19.5 4.50004C20.4283 5.4283 20.9498 6.68729 20.9498 8.00004C20.9498 9.3128 20.4283 10.5718 19.5 11.5L11.5 19.5C10.5718 20.4283 9.3128 20.9498 8.00004 20.9498C6.68729 20.9498 5.4283 20.4283 4.50004 19.5C3.57178 18.5718 3.05029 17.3128 3.05029 16C3.05029 14.6873 3.57178 13.4283 4.50004 12.5"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M8.5 8.5L15.5 15.5"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_235_5541">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				),
			},
			{
				id: 2,
				to: "ORDERS",
				title: "Orders",
				description: "Efficient order tracking",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_235_6736)">
							<path
								d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9 7H10"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9 13H15"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M13 17H15"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_235_6736">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				),
			},

			{
				id: 4,
				to: "DASHBOARD",
				title: "Alerts",
				description: "Timely stock notifications",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_235_5738)">
							<path
								d="M18 8C18.7956 8 19.5587 8.31607 20.1213 8.87868C20.6839 9.44129 21 10.2044 21 11C21 11.7956 20.6839 12.5587 20.1213 13.1213C19.5587 13.6839 18.7956 14 18 14"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M10 8V19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V14"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M12 7.99995L16.524 4.22995C16.6555 4.12046 16.8154 4.0507 16.9851 4.02885C17.1548 4.00701 17.3271 4.03398 17.482 4.1066C17.6369 4.17922 17.7679 4.29449 17.8597 4.4389C17.9514 4.5833 18.0001 4.75087 18 4.92195V17.0779C18.0001 17.249 17.9514 17.4166 17.8597 17.561C17.7679 17.7054 17.6369 17.8207 17.482 17.8933C17.3271 17.9659 17.1548 17.9929 16.9851 17.971C16.8154 17.9492 16.6555 17.8794 16.524 17.7699L12 13.9999H4C3.73478 13.9999 3.48043 13.8946 3.29289 13.7071C3.10536 13.5195 3 13.2652 3 12.9999V8.99995C3 8.73473 3.10536 8.48038 3.29289 8.29284C3.48043 8.1053 3.73478 7.99995 4 7.99995H12"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_235_5738">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				),
			},
		],
	},
	{
		id: 2,
		title: "Notebook",
		topics: [
			{
				id: 1,
				to: "NOTEBOOK",
				title: "Experiments",
				description: "Digital lab workspace",
				icon: (
					<svg
						width="20"
						height="22"
						viewBox="0 0 20 22"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7 5V9.5012C7 10.0521 7 10.3276 6.93132 10.5829C6.87047 10.809 6.77037 11.0228 6.63557 11.2143C6.48344 11.4305 6.27182 11.6068 5.84859 11.9595L2.15141 15.0405C1.72818 15.3932 1.51656 15.5695 1.36443 15.7857C1.22963 15.9772 1.12953 16.191 1.06868 16.4171C1 16.6724 1 16.9479 1 17.4988V17.8C1 18.9201 1 19.4802 1.21799 19.908C1.40973 20.2843 1.71569 20.5903 2.09202 20.782C2.51984 21 3.0799 21 4.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V17.4988C19 16.9479 19 16.6724 18.9313 16.4171C18.8705 16.191 18.7704 15.9772 18.6356 15.7857C18.4834 15.5695 18.2718 15.3932 17.8486 15.0405L14.1514 11.9595C13.7282 11.6068 13.5166 11.4305 13.3644 11.2143C13.2296 11.0228 13.1295 10.809 13.0687 10.5829C13 10.3276 13 10.0521 13 9.5012V5M6.3 5H13.7C13.98 5 14.12 5 14.227 4.9455C14.3211 4.89757 14.3976 4.82108 14.4455 4.727C14.5 4.62004 14.5 4.48003 14.5 4.2V1.8C14.5 1.51997 14.5 1.37996 14.4455 1.273C14.3976 1.17892 14.3211 1.10243 14.227 1.0545C14.12 1 13.98 1 13.7 1H6.3C6.01997 1 5.87996 1 5.773 1.0545C5.67892 1.10243 5.60243 1.17892 5.5545 1.273C5.5 1.37996 5.5 1.51997 5.5 1.8V4.2C5.5 4.48003 5.5 4.62004 5.5545 4.727C5.60243 4.82108 5.67892 4.89757 5.773 4.9455C5.87996 5 6.01997 5 6.3 5ZM3.5 16H16.5C16.9647 16 17.197 16 17.3902 16.0384C18.1836 16.1962 18.8038 16.8164 18.9616 17.6098C19 17.803 19 18.0353 19 18.5C19 18.9647 19 19.197 18.9616 19.3902C18.8038 20.1836 18.1836 20.8038 17.3902 20.9616C17.197 21 16.9647 21 16.5 21H3.5C3.03534 21 2.80302 21 2.60982 20.9616C1.81644 20.8038 1.19624 20.1836 1.03843 19.3902C1 19.197 1 18.9647 1 18.5C1 18.0353 1 17.803 1.03843 17.6098C1.19624 16.8164 1.81644 16.1962 2.60982 16.0384C2.80302 16 3.03534 16 3.5 16Z"
							stroke="#2C52F7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				),
			},
			{
				id: 3,
				title: "Protocols",
				description: "Accessible protocol library",
				to: "PROTOCOLS",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_235_9811)">
							<path
								d="M3.5 5.5L5 7L7.5 4.5"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M3.5 11.5L5 13L7.5 10.5"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M3.5 17.5L5 19L7.5 16.5"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M11 6H20"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M11 12H20"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M11 18H20"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_235_9811">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				),
			},
			{
				id: 2,
				to: "INSIGHTS",
				title: "Version control",
				description: "Track changes effortlessly.",
				icon: (
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M1 1V11.2C1 12.8802 1 13.7202 1.32698 14.362C1.6146 14.9265 2.07354 15.3854 2.63803 15.673C3.27976 16 4.11984 16 5.8 16H13M13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16ZM1 6L13 6M13 6C13 7.65686 14.3431 9 16 9C17.6569 9 19 7.65685 19 6C19 4.34315 17.6569 3 16 3C14.3431 3 13 4.34315 13 6Z"
							stroke="#2C52F7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				),
			},

			{
				id: 4,
				to: "LIVE_EDITING",
				title: "Reports",
				description: "Quick data summaries",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_235_5798)">
							<path
								d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M13 3H11C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5C15 3.89543 14.1046 3 13 3Z"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9 17V12"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M12 17V16"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M15 17V14"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_235_5798">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				),
			},
		],
	},
	{
		id: 3,
		title: "Platform",
		topics: [
			{
				id: 1,
				title: "Genemod AI",
				to: "GENEMOD_AI",
				description: "GPT-powered lab assistant",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10 2.00008V6.6605C10 6.87768 10 6.98626 9.9669 7.07264C9.93568 7.15413 9.89435 7.21328 9.82858 7.27063C9.75885 7.33142 9.64593 7.37279 9.42008 7.45553C6.54892 8.50734 4.5 11.2644 4.5 14.5C4.5 18.6421 7.85786 22 12 22C16.1421 22 19.5 18.6421 19.5 14.5C19.5 11.2644 17.4511 8.50734 14.5799 7.45553C14.3541 7.37279 14.2411 7.33142 14.1714 7.27063C14.1056 7.21328 14.0643 7.15413 14.0331 7.07264C14 6.98626 14 6.87768 14 6.6605V2.00008M8.5 2H15.5"
							stroke="#2C52F7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				),
			},
			{
				id: 3,
				to: "INFORMATION_TECHNOLOGY",
				title: "Security",
				description: "Robust data protection",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9 11.5001L11 13.5001L15.5 9.00011M20 12.0001C20 16.9086 14.646 20.4785 12.698 21.615C12.4766 21.7442 12.3659 21.8087 12.2097 21.8422C12.0884 21.8682 11.9116 21.8682 11.7903 21.8422C11.6341 21.8087 11.5234 21.7442 11.302 21.615C9.35396 20.4785 4 16.9086 4 12.0001V7.21772C4 6.4182 4 6.01845 4.13076 5.67482C4.24627 5.37126 4.43398 5.10039 4.67766 4.88564C4.9535 4.64255 5.3278 4.50219 6.0764 4.22146L11.4382 2.21079C11.6461 2.13283 11.75 2.09385 11.857 2.07839C11.9518 2.06469 12.0482 2.06469 12.143 2.07839C12.25 2.09385 12.3539 2.13283 12.5618 2.21079L17.9236 4.22146C18.6722 4.50219 19.0465 4.64255 19.3223 4.88564C19.566 5.10039 19.7537 5.37126 19.8692 5.67482C20 6.01845 20 6.4182 20 7.21772V12.0001Z"
							stroke="#2C52F7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				),
			},
			{
				id: 2,
				title: "Integrations",
				to: "INTEGRATIONS",
				description: "Seamless system connectivity",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_235_1332)">
							<path
								d="M7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20Z"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M7 8C8.10457 8 9 7.10457 9 6C9 4.89543 8.10457 4 7 4C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8Z"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.8954 4 15 4.89543 15 6C15 7.10457 15.8954 8 17 8Z"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M7 8V16"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V11"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M14 14L17 11L20 14"
								stroke="#2C52F7"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_235_1332">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				),
			},

			{
				id: 4,
				to: "EQUIPMENT",
				title: "Equipment",
				description: "Booking and scheduling",
				icon: (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M21 10H3M16 2V6M8 2V6M18 21V15M15 18H21"
							stroke="#2C52F7"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				),
			},
		],
	},
];

const Products = () => {
	return <ColumnsTemplate columns={links} />;
};

export default Products;
